/**
 * Gate 1 — Test Strategy REST client.
 */
import axios from "axios";
import { API_BASE_URL } from "../config";

const base = (projectId) => `${API_BASE_URL}/projects/${projectId}/gate1/test-strategy`;

export async function fetchTestStrategy(projectId) {
  const res = await axios.get(base(projectId));
  return res.data;
}

export async function generateTestStrategy(projectId) {
  const res = await axios.post(`${base(projectId)}/generate`);
  return res.data;
}

export async function saveCustomStrategy(projectId, payload) {
  const res = await axios.post(`${base(projectId)}/custom`, payload);
  return res.data;
}

export async function modifyGeneratedItem(projectId, payload) {
  const res = await axios.post(`${base(projectId)}/modify`, payload);
  return res.data;
}
